import $ from "jquery";

$(document).ready(function () {
    if ($('.bkp-view, .ebkph-view, .bkdb-view, .my--positions-view').length >= 1) {
        project.init();
    }
});

var project = {
    container: null,
    htmlEl: null,
    addPositionButton: null,
    calculationId: null,
    projectId: null,
    isCalculation: true,
    currentOpenedLevel: 0,

    init: function () {
        this.htmlEl = $('.main-page .calculation');
        this.container = $('#object');
        this.calculationId = this.container.attr('data-calculationId');
        this.projectId = this.container.attr('data-templateId');
        this.isCalculation = this.calculationId !== "";
        this.isEbkphCalculation = $('.main-page.ebkph-view').length === 1;
        this.type = this.container.attr('data-type') || 'default';

        this.initSearch();
        this.loadProject();
    },

    loadProject: function () {
        if (project.calculationId === "" && project.projectId === "") {
            return;
        }

        project.htmlEl.find('.main-content').applyLoader(true, "Projektdaten werden vorbereitet ...");

        if (!project.isCalculation) {
            project.loadProjectTable();
            return;
        }
        if (!project.calculationId) {
            return;
        }
        var prepareUrl = "/Project/PrepareProjectCalculationTable/" + project.calculationId;
        progress.startBackground(prepareUrl, {
            onStarted: function (data) {
                if (data.recalculationNeeded) {
                    $('body').changeLoader('Investitionsprognose wird neu berechnet. Dieser Vorgang kann 1-2 Minuten dauern');
                }
            },
            onFinished: function (data) {
                project.loadProjectTable();
            },
            onError: function (data) {
                $('body').hideLoader();
                messaging.showPermanentGlobalMessage('danger', null, 'Fehler beim Neurechnen der Investitionsprognose...');
            }
        });
    },

    loadProjectTable: function () {
        if (project.type === 'myposititons') {
            project.htmlEl.find('.main-content').hideLoader();
            $(project).trigger('projectloaded', {});
            return;
        }
        project.htmlEl.find('.main-content').applyLoader(true, "Lade Projektdaten ...");
        var tableUrl = (project.isCalculation) ? "/Project/ProjectCalculationTable/" + project.calculationId : "/Project/TemplateCalculationViewTable/" + project.projectId;
        var data = {type: project.container.attr('data-type') || 'default'};
        connection.getHtmlPart(tableUrl, {
            timeout: 120000,
            data: data,
            onSuccess: function (data) {
                project.container.html(data);
                project.container.find('tr').addClass('level-1');
                $.each(project.container.find('.meta span'), function () {
                    var me = $(this);
                    switch (me.attr('data-action')) {
                        case 'removeClass':
                            $(me.attr('data-target')).removeClass(me.attr('data-class'));
                            break;
                        case 'addClass':
                            $(me.attr('data-target')).addClass(me.attr('data-class'));
                            break;
                        default:
                            $(me.attr('data-target')).html(me.attr('data-value'));
                    }
                });
                project.projectLoaded();
            },
            onComplete: function () {
                project.htmlEl.find('.main-content').hideLoader();
            }
        });
    },

    projectLoaded: function () {
        if ($('.autoopen').length === 1 && !slidein.isMobil) {
            slidein.openUrl($('.autoopen').attr('data-slidein'), function (element) {
            });
        }
        $(project).trigger('projectloaded', {});

        project.container.find('tbody').sortable({
            items: (!authentication.isAdminOrLoginAs ? 'tr.leaf' : 'tr'),
            handle: ".sort-handle",
            helper: function(ev) {
                var row = $(ev.target).closest('[data-id]');
                return '<div class="bg-light d-flex align-items-center px-1" style="background-color:#DCE19A !important;height:27px;border:1px #fff solid;">'+row.find('.positionname').val()+' verschieben</div>';
            },
            axis: "y",
            stop: function (e, ui) {
                var itemEl = $(ui.item);
                var previousTreeNode = itemEl.prevAll(`.node[data-depth="${itemEl.attr('data-depth') - 1}"]`).first();
                console.log(previousTreeNode, itemEl);
                if (authentication.isAdminOrLoginAs || previousTreeNode.attr('data-id') == itemEl.attr('data-tt-parent-id')) {
                    console.log(e, ui);
                    var sortList = {};
                    var siblings = project.container.find(`[data-tt-parent-id="${previousTreeNode.attr('data-id')}"]`);
                    $.each(siblings, function (i, el) {
                        sortList[$(el).attr('data-id')] = i;
                    });
                    connection.getJson("/ProjectTree/MovePosition", {
                        data: {
                            id: itemEl.attr('data-id'),
                            parentId: previousTreeNode.attr('data-id'),
                            sortList: sortList,
                        },
                        onComplete: function () {
                        }
                    });
                    return true;
                }
                return false;
            },
        });

        this.registerInputs(this.container);
        $('[data-recalculate]').click(this.recalculateAll);

        $('[data-reserve]').click(function (ev) {
            ev.stopPropagation();
        });
        connection.applyValueChange($('[data-reserve]'), {
            onChange: function (inputEl) {
                var positionLine = inputEl.parents('tr');
                project.savePositionField(positionLine.attr('data-id'), 'name', inputEl.val());
            }
        });

        onContentReady(this.container);
        project.addPositionButton = $('[data-addslidein]');
        project.addPositionButton.off('click').click(function () {
            project.toggleAddPositionButtons();
        });

        if (window.location.hash) {
            var treeIds = window.location.hash.replace('#', '').split('|');
            project.openTree(treeIds, null, (openedEl) => {
                project.openPositionDetails(null, openedEl.find(openedEl.find(`[data-posslidein]`)[0]));
            });
        }
    },

    toggleAddPositionButtons: function () {
        if (project.addPositionButton.hasClass('is-on')) {
            project.container.find('.pos-btns').remove();
            project.addPositionButton.removeClass('is-on');
        } else {
            var nodes = project.container.find('tr.node,tr.leaf[data-childs="0"]').not('.level-1').not('.level-2');
            var reserveNodes = project.container.find('tr[data-aid="6"],tr[data-aid="7"],tr[data-aid="8"],tr.own-pos[data-childs="0"]');
            $.merge(nodes, reserveNodes);
            if (nodes.length === 0) {
                messaging.showGlobalMessage('warning', null, 'Es sind aktuell keine Positionen sichtbar, welche erweitert werden können.');
            } else {
                var btnGroup = nodes.find('.rel .value .btn-group');
                $('<span class="position-add pos-btns btn btn-light"><i class="fa fa-fw bi-plus"></i>&nbsp; Unterposition hinzufügen</span>').appendTo(btnGroup);
                $('<span class="position-delete pos-btns btn btn-danger"><i class="fa fa-fw bi-trash"></i></span>').appendTo(btnGroup);
                project.addPositionButton.addClass('is-on');
                project.container.find('.position-add').off('click').on('click', ev => {
                    var target = $(ev.currentTarget).closest('.btn-group').find('.btn-context-click');
                    var event = new CustomEvent('click', { detail: { originalEvent: ev.originalEvent } });
                    target[0].dispatchEvent(event);
                    return false;
                });
                // project.container.find('.position-add').off('click').on('click', project.createNewPosition);
                project.container.find('.position-delete').off('click').on('click', project.deletePosition);
            }
        }
    },

    openTree: function (treeIds, openedEl, onSuccess) {
        console.log(treeIds);
        if (treeIds.length === 0) {
            $('body').hideLoader(); // add first, if not present
            $('body').hideLoader();
            if (openedEl != null && openedEl.length > 0) {
                project.htmlEl.animate({
                    scrollTop: openedEl.position(project.htmlEl).top - 5
                }, function () {
                    openedEl.find('.value').css({backgroundColor: '#f00'}).animate({
                        backgroundColor: '#E29570'
                    }, function () {
                        openedEl.find('.value').css({backgroundColor: ''});
                        openedEl.addClass('slidein-active');
                    });
                });
            }
            if (onSuccess) onSuccess(openedEl);
            return;
        }

        var id = treeIds.shift();
        var el = $('#object tr[data-id=' + id + ']');
        if (el.length === 0) {
            return;
        }
        if (el.hasClass('leaf')) {
            project.openTree(treeIds, el, onSuccess);
            return;
        }
        if (el.hasClass('opened')) {
            project.openTree(treeIds, el, onSuccess);
        } else {
            project.openSubPositionsPart(el, function () {
                project.openTree(treeIds, el, onSuccess);
            });
        }
    },

    openSubPositions: function (ev) {
        ev.preventDefault();
        var me = ($(this).is('tr')) ? $(this) : $(this).closest('tr')
        if (window.mypos && mypos.treeTable) {
            if (!me.hasClass('opened')) {
                mypos.treeTable.treetable("expandNode", me.data("ttId"));
            } else {
                mypos.treeTable.treetable("collapseNode", me.data("ttId"));
            }
            return;
        }
        project.openSubPositionsPart(me);
    },

    openLevel1To4: function(bkpRoot, hideEmpty) {
        project.htmlEl.find('.main-content').applyLoader(true, "Lade Positionen ...");
        connection.getJson('/Project/LoadPartsByLevel/' + project.calculationId, {
            timeout: 60000,
            data: {
                type: this.container.attr('data-type') || 'default',
                bkpRoot: bkpRoot,
                hideEmpty: ("undefined" == typeof hideEmpty) ? this.container.is('.hide-empty-positions') : hideEmpty === true,
            },
            onSuccess: function(response) {
                project.htmlEl.find('.main-content').applyLoader(true, "Öffne Positionen ...");
                $.each(response, (id, html) => {
                    var row = project.container.find(`[data-id="${id}"]`);
                    project.addSubPositionsPart(row, html);
                });
                project.htmlEl.find('.main-content').hideLoader();
            },
            onComplete: function () {
                project.htmlEl.find('.main-content').hideLoader();
            },
        });
    },

    closeLevel: function() {
        project.container.find(`[data-depth="1"]`).each(function() {
            var me = $(this);
            if (me.hasClass('opened')) {
                project.closePart(me);
            }
        });
        project.currentOpenedLevel = 0;
    },

    openSubPositionsPart: function (trEl, onSuccess) {
        project.container.find('.pos-btns').remove();
        project.addPositionButton.removeClass('is-on');
        if (trEl.hasClass('progressing')) return;
        //
        var me = trEl;
        progress.startProgress();
        if (!me.hasClass('opened')) {
            if (me.attr('data-depth') === "4") {
                var elements = project.container.find('[data-depth]').filter(function () {
                    return $(this).attr("data-depth") === "4";
                });
                $.each(elements, function () {
                    project.closePart($(this));
                });
            }
            $.ajax({
                url: '/Project/LoadPart/' + me.attr('data-id'),
                data: {type: this.container.attr('data-type') || 'default'},
                timeout: connection.defaultTimeout,
                success: function (data) {
                    project.addSubPositionsPart(me, data, onSuccess);
                },
                error: function (data) {
                    try {
                        var message = (data.responseJSON.error) ? data.responseJSON.error : 'Fehler beim öffnen einer Position.';
                        messaging.showGlobalMessage('danger', null, message);
                    } catch (e) {
                        messaging.showGlobalMessage('danger', null, 'Fehler beim öffnen einer Position.');
                    }
                    if (onSuccess) onSuccess();
                },
                beforeSend: function () {
                    me.addClass('progressing');
                },
                complete: function () {
                    me.removeClass('progressing');
                    progress.endProgress();
                }
            });
        } else {
            project.closePart(me);
            progress.endProgress();
        }
        return false;
    },

    addSubPositionsPart: function(trEl, html, onSuccess) {
        if (trEl.hasClass('opened')) return;
        trEl.addClass('opened');
        var content = $(html.trim());
        trEl.after(content);
        var level = parseInt(trEl.attr('data-depth')) + 1;
        project.container
            .find('[data-parent=' + trEl.attr('data-id') + ']')
            .attr('data-depth', level)
            .addClass('level-' + level);
        $.each(content, function (i, el) {
            var row = $(el);
            if (row.is('tr.node,tr.leaf') && level >= 3) {
                row.find('.btn-toolbar').removeClass('d-none');
            }
            if (row.is('tr[data-aid="6"],tr[data-aid="7"],tr[data-aid="8"],tr.own-pos[data-childs="0"]')) {
                row.find('.btn-toolbar').removeClass('d-none');
            }
        });
        //
        project.registerInputs(content);
        onContentReady(content);
        $(project).trigger('positionopened', {
            parent: trEl
        });
        if (onSuccess) onSuccess(content);
    },

    closePart: function (partEl) {
        if (window.mypos && mypos.treeTable) {
            mypos.treeTable.treetable("collapseNode", partEl.data("ttId"));
            return;
        }
        var depth = parseInt(partEl.attr('data-depth'));
        var next = partEl.next();
        while (depth < parseInt(next.attr('data-depth'))) {
            var theNext = next.next();
            next.remove();
            next = theNext;
        }
        partEl.removeClass('opened');
        return false;
    },

    openPositionDetails: function (ev, newPositionEl) {
        if (ev) ev.preventDefault();
        var me = newPositionEl || $(this);
        var positionLineEl = me.parents('tr');
        $('.slidein-active').removeClass('slidein-active');
        $('.slidein-tree-active').removeClass('slidein-tree-active');

        if (positionLineEl.is('[data-type="treeposition"]')) {
            project.createNewPosition(null, me);
        } else {
            positionLineEl.addClass('slidein-active');
            var parentEl = $(`[data-tt-id="${positionLineEl.attr('data-tt-parent-id')}"]`);
            var idTree = [positionLineEl.attr('data-tt-id')];
            while (parentEl.length > 0) {
                parentEl.addClass('slidein-tree-active');
                idTree.push(parentEl.attr('data-tt-id'));

                parentEl = $(`[data-tt-id="${parentEl.attr('data-tt-parent-id')}"]`);
            }
            slidein.openUrl(me.attr('data-posslidein'), function (element) {
                project.initPositionDetails(element);
                history.replaceState({id: 'project', view: 'details'}, true, location.pathname + '#' + idTree.reverse().join("|"));
            });
        }
    },

    reloadPosition: function (line, onSuccess) {
        $(project).trigger('before-positionreloaded', {
            node: line
        });
        $.ajax({
            url: '/Project/ReloadPosition/' + line.attr('data-id'),
            data: {type: this.container.attr('data-type') || 'default'},
            timeout: connection.defaultTimeout,
            success: function (data) {
                var content = $(data.trim());
                var level = line.attr('data-depth');
                content.attr('data-depth', level)
                    .addClass('level-' + level);

                if (line.hasClass('opened')) {
                    project.closePart(line);
                }
                line.after(content);
                line.remove();

                project.registerInputs(content);
                $(project).trigger('positionreloaded', {
                    node: content
                });
                if (onSuccess) onSuccess(content);
            },
            beforeSend: function () {
                line.addClass('progressing');
            },
            complete: function () {
                line.removeClass('progressing');
                progress.endProgress();
            }
        });
    },

    initPositionDetails: function (element) {
        var itemsTable = element.find('table.items');
        exceltable.init(itemsTable);
        $.each(element.find('.dimension'), function (i, el) {
            var line = $(el);
            project.registerPositionDetails(line);
        });
    },

    registerPositionDetails: function (line) {
        var fields = line.find('input,textarea,[contenteditable]');
        connection.applyValueChange(fields, {
            onChange: function (formEl, oldValue) {
                project.saveDimensionItem(formEl, oldValue);
            }
        });
        line.find('[data-delete]').click(function () {
            project.deleteDimensionItem($(this));
        });
        line.find('[data-template-price]').blur(function () {
            var me = $(this);
            var hasChange = parseFloat(me.text().trim() || 0) !== parseFloat(me.attr('data-template-price').trim() || 0);
            if (hasChange) {
                me.addClass('has-change');
            } else {
                me.removeClass('has-change');
            }
        });
        if (line.is('[data-loadPart]')) {
            line.find('.value').off('click').click(function (event) {
                console.log('value click');
                project.loadDetailPartOf($(this).parents('[data-loadPart]'));
            });
            line.find('input, textarea, [contenteditable], button').off('focus').focus(function (event) {
                console.log('off focus', $(this));
                project.loadDetailPartOf($(this).closest('[data-loadPart]'));
            });
        }
    },

    loadDetailPartOf: function (dataRow) {
        if (dataRow.is('.active.dimension')) return;

        dataRow.parents('table').find('tr.active').removeClass('active');
        dataRow.addClass('active');
        project.loadPart(dataRow, null, function (part, target) {
            target.find('[data-close]').click(function () {
                var activeRow = $('#slidein .active.dimension');
                connection.loadPart($(activeRow.attr('data-reset')));
                activeRow.removeClass('active');
            });
        });
    },

    registerInputs: function (container) {
        var event = new CustomEvent('calculation.part-loaded', {
            bubbles: false,
            detail: { container: container}
        });
        document.dispatchEvent(event);

        var fields = container.find('input,textarea,[contenteditable]');
        connection.applyValueChange(fields, {
            onChange: function (formEl) {
                project.savePosition(formEl);
            }
        });
        $.each(fields, function (i, el) {
            $(el).attr('data-val', $(el).val());
        });
        //
        container.find('.toggle-handler')
            .off('click').on('click', project.openSubPositions);
        container.find('[data-posslidein], .dimension')
            .off('click').on('click', project.openPositionDetails);
        container.find('.position-markers')
            .off('click').on('click', function () {
            project.reloadPosition($(this).parents('tr'));
        });

        project.container.find('tbody.ui-sortable').sortable('refresh');
    },

    createNewPosition: function (ev, tableCellEl, asPricePosition, asBkp, asSumPosition) {
        var me = tableCellEl || $(this);
        var row = me.is('tr') ? me : $(me.parents('tr'));
        project.container.find('.pos-btns').remove();
        project.addPositionButton.removeClass('is-on');

        var mainUrl = project.addPositionButton.attr('data-addslidein');
        var urlParams = [];
        urlParams.push('parentId='+row.attr('data-id'));
        var pricePsitionParam = (asPricePosition || asSumPosition) ? 1 : 2;
        urlParams.push('pricePosition='+pricePsitionParam);
        if (asBkp) {
            urlParams.push('createBkp=true');
        }
        if (asSumPosition) {
            urlParams.push('createSumPosition=true');
        }

        slidein.openUrl(project.addPositionButton.attr('data-addslidein')+'&'+urlParams.join('&'));
        return false;
    },

    copyPosition: function (ev, tableCellEl, copyToMyPositions) {
        var me = tableCellEl || $(this);
        var row = me.is('tr') ? me : $(me.parents('tr'));
        if (typeof copyToMyPositions == 'undefined') copyToMyPositions = false;

        messaging.askYesNo('Position duplizieren', 'Willst du die Position wirklich duplizieren?', function () {
            project.htmlEl.find('.main-content').applyLoader(true, "Kopiere Position...");
            connection.getJson('/Project/CopyPosition/' + row.attr('data-id'), {
                timeout: 120000,
                data: {
                    "nameAppendix": "(kopie)",
                    "copyToMyPositions": copyToMyPositions,
                },
                onSuccess: function () {
                    var parentRowEl = $('tr[data-id="' + row.attr('data-parent') + '"]');
                    project.closePart(parentRowEl);
                    project.openSubPositionsPart(parentRowEl);
                },
                onComplete: function () {
                    project.htmlEl.find('.main-content').hideLoader();
                },
            });
        });
    },

    renamePosition: function (ev, tableCellEl) {
        var me = tableCellEl || $(this);
        var row = me.is('tr') ? me : $(me.parents('tr'));

        slidein.openUrl('/Project/PositionSettingsSlideIn/' + row.attr('data-id'));

        // BootstrapDialog.show({
        //     type: BootstrapDialog.TYPE_LIGHT,
        //     title: 'Position umbenennen',
        //     closable:true,
        //     message: function (dialog) {
        //         return $('<div class="form-group">' +
        //             '  <label>Neuer Positions-Name</label>' +
        //             '  <input type="text" class="form-control" name="PositionName" value="'+row.find('.positionname').val()+'" />' +
        //             '</div>');
        //     },
        //     buttons: [{
        //         label: 'Ja',
        //         cssClass: 'btn-success',
        //         hotkey: 13, // Enter.
        //         action: function (dialog) {
        //             var newName = dialog.$modalBody.find('[name="PositionName"]').val();
        //             connection.getJson('/Project/RenamePosition', {
        //                 data: {
        //                     id: row.attr('data-id'),
        //                     name: newName,
        //                 },
        //                 onSuccess: function(data) {
        //                     row.find('.positionname').val(newName).attr('data-val', newName);
        //                     dialog.close();
        //                 },
        //                 onError: function(response) {
        //                     connection.addFormErrors(dialog.$modalBody, response);
        //                 }
        //             });
        //         }
        //     }, {
        //         label: 'Abbrechen',
        //         cssClass: 'btn-danger',
        //         hotkey: 27, // Esc.
        //         action: function (dialog) {
        //             dialog.close();
        //         }
        //     }]
        // });
    },

    movePosition: function (ev, tableCellEl) {
        //
    },

    togglePositionActive: function (ev, tableCellEl) {
        var row = tableCellEl || $($(this).parents('tr'));
        //
        $.ajax({
            url: '/Project/TogglePositionActive/' + row.attr('data-id'),
            type: 'post',
            dataType: 'json',
            success: function (response) {
                if (response.active) {
                    row.removeClass('inactive');
                } else {
                    row.addClass('inactive');
                }
            },
        });
    },

    deletePosition: function (ev, tableCellEl) {
        var row = tableCellEl || $($(this).parents('tr'));
        if (row.hasClass('opened')) {
            project.closePart(row);
        }

        messaging.askYesNo('Position löschen', 'Willst du die Position "'+row.find('.positionname').val().trim()+'" wirklich löschen?', function () {
            var netPrice = row.find('[class*=netprice]').html()?.trim() || '0.00';
            if (row.find('[class*=netprice]').length > 0 && netPrice !== '0.00') {
                connection.getJson('/Project/SavePositionAmount/' + row.attr('data-id'), {
                    data: { amount: "" },
                    onSuccess: () => {
                        project.deletePositionRow(row);
                    },
                });
                return;
            }

            project.deletePositionRow(row);
        }, function () {
            project.container.find('.pos-btns').remove();
        });
        return false;
    },

    deletePositionRow: function (row) {
        if (row.is('.slidein-active')) {
            slidein.close();
        }
        var task = {
            run: function (onComplete, onTaskError) {
                $('body .main-content').applyLoader(true, "Lösche Position...");
                $.ajax({
                    url: '/Project/DeletePosition/' + row.attr('data-id'),
                    type: 'post',
                    dataType: 'json',
                    timeout: connection.defaultTimeout,
                    success: function () {
                        project.container.find('.pos-btns').remove();
                        messaging.showGlobalMessage('success', null, 'Die Position wurde gelöscht.');
                        row.remove();
                    },
                    error: function (data) {
                        if (data && data.statusText === 'timeout') {
                            onTaskError(null, true);
                            return;
                        }
                        onTaskError(connection.getErrorMessageOf(data, 'Fehler beim löschen der Position.'), false, function () {
                            //revert
                        });
                    },
                    complete: function () {
                        if (onComplete != null) onComplete();
                        $('body .main-content').hideLoader();
                    }
                });
            }
        };
        taskQueue.add(task);
    },

    savePositionLeafField: function (positionId, positionLeafId, fieldName, value, oldValue, sourceFieldEl) {
        var task = {
            onFinished: function () {
                if (fieldName === 'name') {
                    messaging.showGlobalMessage('success', null, 'Die Position wurde umbenannt.');
                }
            },
            run: function (onComplete, onTaskError, task) {
                var postData = {};
                postData['fieldName'] = fieldName;
                postData[fieldName] = value;
                connection.getJson('/Project/SavePositionLeaf/' + positionLeafId, {
                    type: 'post',
                    data: postData,
                    onSuccess: function (data) {
                        if (task.onFinished) task.onFinished();
                        $(project).trigger('position-saved', {
                            calculationId: data.positionId,
                            positionId: positionId,
                            positionLeafId: positionLeafId,
                            data: data,
                            sourceFieldEl: sourceFieldEl,
                        });
                        project.recalculateFormulas();
                    },
                    onError: function (data) {
                        if (data && data.statusText === 'timeout') {
                            onTaskError(null, true);
                            return;
                        }
                        onTaskError(connection.getErrorMessageOf(data, 'Fehler beim speichern der Position.'), false, function () {
                            if (oldValue) {
                                //revert
                                if (sourceFieldEl.is('[contenteditable]')) {
                                    sourceFieldEl.text(oldValue);
                                } else {
                                    sourceFieldEl.val(oldValue);
                                }
                                sourceFieldEl.attr('data-val', oldValue);
                            }
                        });
                    },
                    onComplete: function () {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    },

    recalculateFormulas: function () {
        var formulaPositions = [];
        $.each($('[data-position-formula]'), (i, el) => {
            formulaPositions.push({
                formula: $(el).attr('data-position-formula'),
                posId: $(el).closest('[data-posid]').attr('data-posid'),
            });
        });

        connection.getJson('/ProjectTree/CalculateFormulas', {
            type: 'get',
            data: {
                calculationId: project.calculationId,
                formulas: formulaPositions,
            },
            onSuccess: function (data) {
                $.each(data, (i, el) => {
                    $(`[data-posid="${el.posId}"] [data-position-formula]`)
                        .text(el.result);
                });
            }
        });
    },

    savePositionField: function (positionId, fieldName, value, sourceFieldEl) {
        debugger;
        var task = {
            onFinished: function () {
                if (fieldName === 'name') {
                    messaging.showGlobalMessage('success', null, 'Die Position wurde umbenannt.');
                }
            },
            run: function (onComplete, onTaskError, task) {
                var postData = {};
                postData[fieldName] = value;
                connection.getJson('/Project/SavePosition/' + positionId, {
                    type: 'post',
                    data: postData,
                    onSuccess: function (data) {
                        if (task.onFinished) task.onFinished();
                        // $(project).trigger('position-saved', {
                        //     calculationId: data.positionId,
                        //     positionId: positionId,
                        //     data: data,
                        //     sourceFieldEl: sourceFieldEl,
                        // });
                    },
                    onError: function (data) {
                        if (data && data.statusText === 'timeout') {
                            onTaskError(null, true);
                            return;
                        }
                        onTaskError(connection.getErrorMessageOf(data, 'Fehler beim speichern der Position.'), false, function () {
                            debugger;
                            //revert
                        });
                    },
                    onComplete: function () {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    },

    savePosition: function (inputEl) {
        var positionLine = inputEl.parents('tr');
        project.savePositionField(positionLine.attr('data-id'), inputEl.attr('data-name'), (inputEl.val() || inputEl.text()), inputEl);
    },

    deleteDimensionItem: function (deleteEl, onComplete) {
        var positionLine = deleteEl.parents('tr');
        var positionTable = deleteEl.parents('table');
        if (positionLine.attr('data-id') === '') return;

        var task = {
            run: function (onComplete, onTaskError) {
                $.ajax({
                    url: positionTable.attr('data-deleteaction') + '/' + positionLine.attr('data-id'),
                    type: 'post',
                    dataType: 'json',
                    timeout: connection.defaultTimeout,
                    success: function (data) {
                        positionLine.next().find('[name=Description]').focus();
                        positionLine.remove();
                        connection.updateFields(data.fields);
                    },
                    error: function (data) {
                        if (data && data.statusText === 'timeout') {
                            onTaskError(null, true);
                            return;
                        }
                        onTaskError(connection.getErrorMessageOf(data, 'Fehler beim speichern des Ausmasses.'), false, function () {
                            //revert
                        });
                    },
                    complete: function () {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    },

    saveDimensionItem: function (inputEl, oldValue, onSuccess) {
        var positionLine = inputEl.parents('tr');
        var positionTable = inputEl.parents('table');
        console.log('saveDimensionItem', positionLine, inputEl);
        var task = {
            run: function (onComplete, onTaskError) {
                if (positionTable.attr('data-saveaction') != null) {
                    var amountEl = positionLine.find('div[data-name=Amount]');
                    if (parseFloat(amountEl.text()) > 0 && amountEl.attr('data-corrSign') === "-") {
                        amountEl.text(amountEl.attr('data-corrSign') + Math.abs(amountEl.text()));
                    }
                    var postData2 = positionLine.find('input,textarea,[contenteditable]').serializeArray();
                    var postData = {};
                    postData['corrSign'] = amountEl.attr('data-corrSign');
                    $.each(postData2, function (i, val) {
                        postData[val.name] = val.value;
                    });
                    console.log('saveDimensionItem', postData);
                    $.each(positionLine.find('[data-name][contenteditable]'), function () {
                        var me = $(this);
                        if (["Amount", "Length", "Height", "Depth"].indexOf(me.attr('data-name')) >= 0) {
                            me.attr('data-val', me.text());
                        }
                        postData[me.attr('data-name')] = me.text().trim();
                    });
                    console.log('saveDimensionItem', postData);
                    $.each(positionLine.find('.dd-selected-value'), function () {
                        var me = $(this);
                        postData[me.attr('name')] = me.val().trim();
                    });
                    postData['Selected'] = positionLine.find('.price-selection .active').length === 1;
                    console.log('saveDimensionItem', postData);
                    $.ajax({
                        url: positionTable.attr('data-saveaction') + '/' + positionLine.attr('data-id'),
                        type: 'post',
                        dataType: 'json',
                        timeout: connection.defaultTimeout,
                        data: postData,
                        success: function (data) {
                            if (positionLine.attr('data-id') === '') {
                                positionLine.attr('data-id', data.id);
                                positionLine.find('.line-total-').removeClass('line-total-').addClass('line-total-' + data.id);
                                positionLine.find('.disabled').removeClass('disabled');

                                debugger;
                                var lineHtml = data.empty.trim().replaceAll("__id__", data.id);
                                var line = $(lineHtml);
                                positionLine.after(line);
                                exceltable.init(line);
                                project.registerPositionDetails(line);
                                project.registerSumItems(line.find('.detailed-input'));
                                line.find('[data-loadPart]').click(function () {
                                    project.loadPart($(this));
                                });
                                $('#slidein .price-table tbody')
                                    .sortable('refresh');
                                exceltable.selectNextCell(inputEl);
                            }
                            connection.updateFields(data.fields);
                            if (data.updateDom) {
                                connection.updateDom(data.updateDom);
                            }
                            if (onSuccess) onSuccess(data);
                            //
                            if (window.project_ebkph.isActive && inputEl.closest('[data-positionleafid]')) {
                                var positionLeafId = inputEl.closest('[data-positionleafid]').attr('data-positionleafid');
                                var price = data.fields['netprice-leaf-plain-' + positionLeafId].trim();
                                project_ebkph.changePositionPrice(null, positionId, positionLeafId, project.calculationId, price);
                            } else {
                                var positionId = positionTable.attr('data-id');
                                var amountEl = $('#object [data-id=' + positionId + '] .amount-' + positionId + ', #slidein #position-detail-header .amount-' + positionId + '');
                                if (amountEl.length >= 1) {
                                    project.savePosition($(amountEl[0]));
                                }
                            }
                        },
                        error: function (data) {
                            debugger;
                            if (data && data.statusText === 'timeout') {
                                onTaskError(null, true);
                                return;
                            }
                            onTaskError(connection.getErrorMessageOf(data, 'Fehler beim Laden des Inhalts.'), false, function () {
                                if (inputEl.is('[contenteditable]')) {
                                    inputEl.text(oldValue);
                                } else {
                                    inputEl.val(oldValue);
                                }
                                inputEl.attr('data-val', oldValue);
                            });
                        },
                        complete: function () {
                            if (onComplete != null) onComplete();
                        }
                    });
                } else {
                    if (onComplete != null) onComplete();
                }
            }
        };
        taskQueue.add(task);
    },

    registerSumItems: function (elements) {
        elements.off('click').click(function () {
            project.openDetailedInput($(this).parent());
        });
    },

    openDetailedInput: function (container) {
        var formulaEl = container.find('.formula');
        var resultEl = container.find('.formulaResult');
        var dropdownMenu = container.find('.dropdown-menu');

        if (dropdownMenu.find('.formula').length === 0) {
            var dialogEl = $(`<div class="px-3" style="width:300px;">
    <h6 class="d-flex align-items-center">
        Formel:
        <div class="ml-auto d-flex">
            <span class="btn btn-sm refresh" title="Formel updaten"><i class="fa bi-arrow-repeat"></i></span>
            <span class="btn btn-sm clear" title="Formel löschen"><i class="fa bi-trash text-danger"></i></span>
        </div>
    </h6> 
    <div class="input-group">
        <input type="text" class="form-control h-100 formula" value="${formulaEl.val()}" />
        <div class="input-group-append bg-lightgray">
            <div class="btn btn-outline-dark btn-sm disabled bg-lightgray d-flex align-items-center">
                = <span class="formulaResult" data-cell="A1" data-formula="ROUND(${formulaEl.val()||'0'}, 2)"></span>
            </div>
        </div>
    </div>
    <p class="mb-0 mt-2 text-muted">Gib ins Feld oben eine Formel ein. (z.B. 1+6)</p>
    <div class="text-right">
        <span class="btn btn-success btn-sm" data-ok><i class="fa bi-check"></i> OK</span>
    </div>
</div>`);
            dropdownMenu.append(dialogEl);

            var dlgFormula = dialogEl.find('.formula');
            var dlgResult = dialogEl.find('.formulaResult');
            dlgResult.html(parseFloat(resultEl.text() || '0').toFixed(2));
            dialogEl.find('.btn.refresh').click(function () {
                sheet.getCell('A1').calculate();
            });
            dialogEl.find('.btn.clear').click(function () {
                dlgFormula.val('');
                sheet.getCell('A1').setFormula('').calculate();
                dlgFormula.focus();
            });
            dialogEl.submit(function () {
                var formula = dlgFormula.val();
                sheet.getCell('A1').setFormula(`ROUND(${formula}, 2)`).calculate();
                return false;
            });
            dlgFormula.on('blur', function () {
                var formula = dlgFormula.val();
                if (formula.trim() === '') {
                    sheet.getCell('A1').setFormula('').calculate();
                } else {
                    formula = formula.replace(/[,\.\d]+/g, function (m) {
                        var start = m.substr(0, 1);
                        if (start === '.' || start === ',') {
                            return 0 + m;
                        }
                        return m;
                    });
                    dlgFormula.text(formula);
                    sheet.getCell('A1').setFormula(`ROUND(${formula}, 2)`).calculate();
                }
            });

            var calc  = dialogEl.calx();
            var sheet = calc.calx('getSheet');
            sheet.getCell('A1').calculate();

            dropdownMenu.parent().on('hide.bs.dropdown', (ev) => {
                var $target = (ev.clickEvent) ? $(ev.clickEvent.target) : $(ev.currentTarget);
                if ($target.closest('.dropdown').length === 1 && !$target.is('[data-ok]')) {
                    ev.preventDefault();
                    return false;
                }
                var formula = dlgFormula.val();
                formulaEl.val(formula).trigger('blur');
                resultEl.text(dlgResult.html()).trigger('blur');
                if (formula.trim() === '') {
                    container.find('.detailed-input').removeClass('isvisible');
                    resultEl.text('0').trigger('blur');
                } else {
                    container.find('.detailed-input').addClass('isvisible');
                }
            });
        }
    },

    recalculateAll: function () {
        $('body').applyLoader(true, "Investitionsprognose wird neu gerechnet");
        var me = $(this);
        progress.startBackground(me.attr('data-recalculate'), {
            onStarted: function () {
                $('body').changeLoader('Investitionsprognose wird neu gerechnet');
            },
            onFinished: function (data) {
                $('body').changeLoader('Seite wird neu geladen');
                location.reload();
            },
            onError: function (data) {
                $('body').hideLoader();
                messaging.showPermanentGlobalMessage('danger', null, 'Fehler beim Neurechnen der Investitionsprognose...');
            }
        });
    },

    loadPart: function (me, onComplete, onSuccess) {
        connection.loadPart(me, onComplete, onSuccess);
    },

    loadJson: function (url, onComplete, onSuccess) {
        connection.loadJson(url, onComplete, onSuccess);
    },

    searchTimer: null,
    initSearch: function (inputEl, callback) {
        $.each(inputEl || $('input.pos-search'), function (index, el) {
            var field = $(el);
            if (field.parent().is('.autocompleter-container')) return;

            var groupAppend = field.next('.input-group-append');
            var container = $('<div class="input-group autocompleter-container"></div>');
            field.wrap(container);
            container = field.parent('div');
            var displayEl = field.clone();
            displayEl.attr('id', displayEl.attr('id') + 'display' + Math.ceil(Math.random() * 200))
                .attr('name', '')
                .attr('data-val', field.attr('fullvalue'))
                .attr('placeholder', 'Suche mit Enter starten..')
                .val(field.attr('fullvalue'));
            field.addClass('d-none').after(displayEl);
            $('<div class="input-group-prepend loader-indicator"><span class="input-group-text"><i class="fa bi-search"></i><i class="fa fa-spinner fa-spin"></i></span></div>').insertAfter(field);
            var dropdownEl = $('<div class="dropdown-container dd-options pos-search ctl-autocompleter-options"></div>').css({'position': 'absolute'}).hide();
            dropdownEl.addClass('menu-position-' + (field.attr('data-menu-position') || 'bottom'));
            displayEl.after(dropdownEl);

            displayEl.on('keydown', function (ev) {
                if (ev.keyCode === $.ui.keyCode.ENTER) return false;
            });
            displayEl.on('keyup', function (ev) {
                var page = 0;
                if (project.searchTimer) clearTimeout(project.searchTimer);
                project.searchTimer = setTimeout(function () {
                    project.dropdownPositioning(container, dropdownEl);
                    dropdownEl.show().html('suche läuft ...');
                    project.doSearch(container, displayEl, dropdownEl, page, callback);
                }, 1000);
                if (ev.keyCode === $.ui.keyCode.ENTER) {
                    ev.preventDefault();
                    if (project.searchTimer) clearTimeout(project.searchTimer);
                    project.dropdownPositioning(container, dropdownEl);
                    dropdownEl.show().html('suche läuft ...');
                    project.doSearch(container, displayEl, dropdownEl, page, callback);
                    $('body').on('click.search', function (ev) {
                        if ($(ev.target).parents('.autocompleter-container').length === 0) {
                            project.closeSearch(displayEl, dropdownEl);
                        }
                    });
                    return false;
                }
                if (ev.keyCode === $.ui.keyCode.ESCAPE) {
                    project.closeSearch(displayEl, dropdownEl);
                }
            });
            if (groupAppend.length > 0) {
                groupAppend.appendTo(field.parent());
            }
            displayEl.focus();
        });
    },

    dropdownPositioning: function (container, dropdownEl) {
        dropdownEl.css({
            'width': container.outerWidth()
        }).position({
            'my': 'top left',
            'target': 'bottom left'
        });
    },

    doSearch: function (container, field, dropdownEl, page, callback) {
        container.addClass('autocompleter-loading');
        connection.getJson(field.attr('data-url'), {
            timeout: 30000,
            data: {
                projectCalculationId: field.attr('data-projectCalculationId'),
                templateId: field.attr('data-templateId'),
                search: field.val(),
                page: page
            },
            onSuccess: function (data) {
                container.removeClass('autocompleter-loading');
                var list = $('<ul class=""></ul>');
                dropdownEl.empty();
                list.appendTo(dropdownEl);
                if (data.data.length === 0) {
                    $('<li class="empty">Keine Positionen gefunden ...</li>').appendTo(list);
                } else {
                    $('<div class="paging"><i class="fa bi-chevron-left disabled prev"></i> <i class="fa bi-chevron-right disabled next"></i> <span>' + (page + 1) + '/' + data.pages + ' Seiten</span> <i class="fa bi-x-lg"></i></div>').prependTo(dropdownEl);
                    if (page > 0) {
                        container.find('.prev').removeClass('disabled').on('click', function () {
                            project.doSearch(container, field, dropdownEl, page - 1, callback);
                        });
                    }
                    if (data.hasMorePages) {
                        container.find('.next').removeClass('disabled').on('click', function () {
                            project.doSearch(container, field, dropdownEl, page + 1, callback);
                        });
                    }
                    container.find('.bi-x-lg').click(function () {
                        project.closeSearch(field, dropdownEl);
                    });

                    for (var i = 0; i < data.data.length; i++) {
                        var item = data.data[i];
                        var hint = (item.hint !== undefined) ? ' <span class="hint">' + item.hint + '</span>' : '';
                        $('<li data-i="' + i + '"><a class="dd-option">' + item.label + hint + '</a></li>')
                            .click(function () {
                                project.closeSearch(field, dropdownEl);
                                var item = data.data[$(this).attr('data-i')];
                                if (callback != null) {
                                    callback(item);
                                    return;
                                }
                                var treeIds = item.value.split(',');
                                $('body').applyLoader(true, "Position wird geöffnet");
                                project.openTree(treeIds);
                            })
                            .appendTo(list);
                    }
                }
            },
            onError: function () {
                container.removeClass('autocompleter-loading');
                dropdownEl.html("Die Suche wurde abgebrochen, versuche es nochmals...");
            }
        });
    },

    closeSearch: function (field, dropdownEl) {
        field.val('');
        dropdownEl.empty().hide();
        $('body').off('click.search');
    },

    initTreeSelect: function (autoCompleterValueEl, btn, callback) {
        var container = btn.closest('.autocompleter-container');
        var dropdownEl = container.find('.dropdown-container');
        btn.click(function () {
            if (dropdownEl.is(':visible')) {
                dropdownEl.empty().hide();
                $('body').off('click.search');
            } else {
                $('body').on('click.search', function (ev) {
                    if ($(ev.target).parents('.autocompleter-container').length === 0) {
                        dropdownEl.empty().hide();
                    }
                });
                container.addClass('autocompleter-loading');
                dropdownEl.show().html('suche läuft ...');
                project.openTreeSelect(btn, container, dropdownEl, callback, btn.attr('data-current-parent-id') || null);
            }
        });
    },

    openTreeSelect: function (btn, container, dropdownEl, callback, parentId) {
        connection.getJson(btn.attr('data-tree-selector'), {
            timeout: 10000,
            data: {
                parentId: parentId,
            },
            onSuccess: function (data) {
                container.removeClass('autocompleter-loading');
                var list = $('<ul class=""></ul>');
                project.dropdownPositioning(container, dropdownEl);
                dropdownEl.empty();
                list.appendTo(dropdownEl);
                if (parentId !== null) {
                    $('<li data-i="' + i + '" class="bg-light border-bottom"><a class="dd-option" href="#">' +
                        '<span class="btn btn-sm px-0 btn-form d-inline-flex"><i class="fa fa-fw fa-arrow-up"></i></span> ' +
                        data.parentName + '</a></li>')
                        .click(function () {
                            project.openTreeSelect(btn, container, dropdownEl, callback, data.parentId);
                        })
                        .appendTo(list);
                }
                if (data.positions.length === 0) {
                    $('<li class="empty p-2">Keine Positionen gefunden ...</li>').appendTo(list);
                }
                for (var i = 0; i < data.positions.length; i++) {
                    var item = data.positions[i];
                    if (!item.isLeaf) {
                        var itemEl = $('<li data-i="' + i + '" style="display:flex!important;" class="align-items-center border-bottom">' +
                            '  <a class="dd-option d-flex align-items-center border-0" href="#" style="flex: 1 1 auto;">' +
                            '    ' + (item.isLeaf ? '<i class="fa fa-fw"></i>' : '<span class="btn btn-sm px-1 mr-1 btn-outline-dark" data-id="'+item.id+'"><i class="fa fa-fw bi-plus"></i></span>') +
                            ((!item.isLeaf) ? '    <span class="select">' + item.label + '</span>' : item.label) +
                            '  </a>' +
                            // ((!item.isLeaf) ? '  <span class="btn btn-dark btn-sm ml-auto mr-2" data-select><i class="fa fa-fw fa-check-circle"></i></span>' : '') +
                            '</li>');
                        itemEl.find('a .btn').click(function () {
                            project.openTreeSelect(btn, container, dropdownEl, callback, $(this).attr('data-id'));
                        });
                        itemEl.find('a .select').click(function () {
                            var item = data.positions[$(this).closest('[data-i]').attr('data-i')];
                            project.closeSearch(container.find('.ctl-autocompleter'), dropdownEl);
                            if (callback != null) {
                                callback(item);
                                return;
                            }
                        });
                        itemEl.appendTo(list);
                    }
                }
                // }
            },
            onError: function () {
                container.removeClass('autocompleter-loading');
                dropdownEl.html("Die Suche wurde abgebrochen, versuche es nochmals...");
            }
        });
    },

};
window.project = project;
